@import 'styles/variables';
@import 'styles/mixins.scss';
@import 'styles/blaze/mixins';

.title {
  @include xxl-sohne;
  transform: translate(-2px, 0px);
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  font-weight: 600;

  @include for-phone-only {
    margin-bottom: unset;
    margin: 0px 50px;
    text-align: center;
    font-size: 32px;
    font-style: normal;
    font-weight: 600;
    line-height: 125%;
  }

  @include for-small-desktop-up {
    padding-top: 60px;
    padding-bottom: 36px;
  }
}

.mailIcon {
  position: absolute;
  left: 10px;
  top: 9px;
}

.leftContent {
  min-width: 280px;
  margin-top: 60px;
  height: 100%;
  margin-bottom: 18px;
  gap: 24px;

  @include for-phone-only {
    justify-content: flex-start;
    gap: 36px;
    margin-top: 24px;
  }
}

.subheaderContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.continueWithEmailButton {
  @include md-sohne;
  display: flex;
  height: 44px;
  padding: 10px;
  justify-content: center;
  color: black;
  align-items: center;
  gap: 2px;
  align-self: stretch;
  border-radius: 6px;
  background: var(--dark-80);
  &.hovered {
    color: var(--dark-80);
  }
}

.emailField {
  input {
    height: 40px;
  }
}

.inlineSubmitButton {
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: 100%;
  padding: 0 12px;

  .inlineSubmitButtonIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 24px;
    height: 24px;
    width: 24px;
    background: var(--dark-80);

    svg {
      fill: white;
      width: 16px;
      height: 16px;
    }
  }
}

.loginContainer {
  @include md-sohne;
}

.leftPanel {
  display: flex;
  flex-direction: column;
  justify-content: center;

  @include for-medium-phone-only {
    padding-bottom: 0px;
    padding-top: 0px;
    border: none;
  }
}

.button {
  width: 100%;
}

.samlButton {
  margin-top: 8px;
  color: var(--action-60);

  @include for-tablet-portrait-max {
    margin-top: 20px;
  }
}

.googleLoginButton,
.facebookLoginButton,
.appleLoginButton {
  width: 100%;

  button {
    justify-content: flex-start;

    > span {
      flex: 1;
      display: flex;
      justify-content: center;
    }
  }
}

.errors {
  border: 1px solid var(--negative-50) !important;
  box-sizing: border-box;
}

.termsOfServiceAndPrivacyPolicy {
  @include xs-sohne-book;
  color: rgba(0, 0, 0, 0.8);
  text-align: center;
  padding: 10px;

  span {
    font-size: 12px;
  }
}

.testimonialContainer {
  height: 164px;
  pointer-events: none;
}

.errorContainer {
  padding: 10px;
  background: $red-20;
  border: 1px solid $red-50;
  border-radius: 4px;
  color: $red-50;

  @include for-small-desktop-up {
    margin: 20px 0;
  }

  @include for-tablet-portrait-max {
    margin: 16px 0;
  }

  p {
    margin: 0;
  }
}

.errorMessage {
  button {
    font-weight: 600;
    border-bottom: 1px solid;
  }
}

.createAccountButton {
  color: white;
  border-radius: 6px;
  background: rgba(0, 0, 0, 0.8);
  padding: 15px !important;

  span {
    margin: 0 auto;
  }
}

.loginWrapper {
  min-height: 100dvh;
  height: 100dvh;
  width: 100dvw;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  overflow-y: auto;

  @include for-small-desktop-up {
    align-items: center;
  }

  .loginContent {
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100dvh;
    align-self: flex-start;

    @include for-small-desktop-up {
      min-width: 450px;
      padding: 0px;
    }

    .loginLeftContent {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: start;
      padding: 72px 20px 0 20px;
      gap: 25px;
      flex: 0;

      @include for-small-desktop-up {
        gap: 36px;
        padding: 0;
        justify-content: center;
        flex: 1;
      }

      .buttonsContainer {
        gap: 8px;
        max-width: 420px;

        @include for-small-desktop-up {
          max-width: 320px;
        }
      }

      .reset {
        @include xs-sohne-medium;
        color: var(--negative-50);
        text-decoration: underline;
      }

      .resetPasswordError {
        align-items: normal;
      }

      .form {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .formGap {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }

        .showPasswordButton {
          right: 8px;
          bottom: 0px;

          @include for-desktop-only {
            bottom: 8px;
          }
        }
      }
    }

    .footer {
      flex-shrink: 0;
      display: flex;
      justify-content: center;
      width: 100%;
      max-width: 480px;
      margin: 0 auto;
      box-sizing: border-box;

      .firstLine {
        display: block;
      }

      .smallLink {
        color: var(--dark-40);
        font-weight: 400;
        text-decoration: underline;
      }
    }
  }
}

.illustrationContainer {
  position: relative;
}

.illustrationImage {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.dfyBannerMobile {
  display: none;

  @include for-small-desktop-down {
    display: flex;
    flex-direction: column;
    gap: 16px;
    align-items: flex-end;
    justify-content: center;
    padding: 24px;
    border-radius: 10px;
    border: 1px solid var(--upgrade-10, rgba(106, 0, 255, 0.1));
    background: rgba(68, 0, 164, 0.5);
    backdrop-filter: blur(100px);
    overflow: hidden;
    margin: 0 20px 20px;
    max-width: 456px;
    align-self: center;
  }
}

.dfyBanner {
  position: absolute;
  bottom: 10px;
  left: 10px;
  max-width: 456px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-end;
  justify-content: center;
  padding: 24px;
  border-radius: 10px;
  border: 1px solid var(--upgrade-10, rgba(106, 0, 255, 0.1));
  background: rgba(68, 0, 164, 0.5);
  backdrop-filter: blur(100px);
  overflow: hidden;
}

.dfyBanner span,
.dfyBannerMobile span {
  line-height: 140%;
  letter-spacing: 0.14px;
}

.dfyBannerText {
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
}

.dfyHeading h5 {
  line-height: 135%;
  letter-spacing: 0.16px;
}

.dfyBannerActions {
  display: flex;
  gap: 11px;
  align-items: center;
  justify-content: flex-end;

  @include for-medium-phone-only {
    flex-direction: column;
    align-items: stretch;
    width: 100%;
  }
}

.dfyButton {
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: center;
  padding: 8px;
  padding-left: 11px;
  border-radius: 8px;
  background: var(--light-100, white);
  border: 1px solid var(--upgrade-10, rgba(106, 0, 255, 0.1));
  white-space: nowrap;
  text-decoration: none;

  span {
    line-height: 104%;
  }

  svg {
    flex-shrink: 0;
  }
}
